import ErrorMessage from "@/errors/ErrorMessage";
import SignInCta from "../SignInCta";
import SignUpCta from "../SignUpCta";
import { ctaContainerCss, messageCss } from "../ViewPageError.style";

const UnauthenticatedUserError = () => {
  return (
    <ErrorMessage headline="Account required">
      <p css={messageCss}>
        Log in to your Newsela account (or sign up for free) to access reading
        content, videos, and more.
      </p>

      <div css={ctaContainerCss}>
        <SignUpCta />
        <SignInCta />
      </div>
    </ErrorMessage>
  );
};

export default UnauthenticatedUserError;
